<template>
  <!--<div id="newProjectMenuPanel" class="menuPanel" v-bind:style="{ height: computedHeight}">
    
  </div>
<div class="card" style="position: relative;">-->
  <div class="target" v-show="!siteDrawMode && !unregSiteDrawMode">
    <Card>
      <template #title>
        {{ newProject ? "New Project" : project.readonly ? "Project Info" : "Edit Project" }}
        <div style="display: flex; justify-content: center">
          <p class="p-component" style="margin-bottom: 0">
            Fill in the information then click next. Draw the zone and site then click next. Define the schedule and
            click Save and Finish
          </p>
          <Button icon="pi pi-window-minimize" class="p-button-rounded p-button-secondary p-button-text"
            style="position: fixed; right: 40px" v-if="activeIndex === 1" @click="minimizeWin()"
            aria-label="Minimize Window" />
          <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
            style="position: fixed; right: 10px" @click="close()" aria-label="Close" />
        </div>
      </template>

      <template #content>
        <TabView v-model:activeIndex="activeIndex" lazy>
          <TabPanel header="Information">
            <template #header>
              <i class="pi pi-question-circle" style="padding-left: 5px"
                v-tooltip="'Fill in the basic Project details'"></i>
            </template>
            <ScrollPanel class="contentPanel">
              <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                  <label for="projectTitle" style="width: 100%">*Project Title:</label>
                  <InputText v-if="!project.readonly && !project.projectTitle.includes('@')"
                    v-model="project.projectTitle" style="width: 100%" aria-describedby="project-help"
                    aria-label="Project Title" @change="onProjectTitleInput"
                    @input="(e) => (showTypingError = e.target.value.includes('@'))" />
                  <label v-else>{{ project.projectTitle.replaceAll("@", " Version ") }}</label>
                  <small v-if="projectTitleExists" id="project-help" class="p-error">Project title already
                    exists!</small>
                  <small v-if="showTypingError" class="p-error">Project title cannot contain '@'.</small>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="submissionPurpose" style="width: 100%">*Purpose of Web-CNMP Submission:
                    <i class="pi pi-question-circle" style="padding-left: 5px" v-tooltip="submissionPurposeTooltip"></i>
                  </label>
                  <Dropdown v-if="!project.readonly" id="submissionPurpose" v-model="selectedSubmissionPurpose"
                    :options="submissionPurposeOptions" optionLabel="label" optionValue="label"
                    aria-label="Submission Purpose" style="width: 100%" @change="onSubmissionPurposeChange" />
                  <InputText v-if="!project.readonly && selectedSubmissionPurpose === 'Others'"
                    v-model="submissionPurposeOther" aria-label="Submission Purpose - Others"
                    style="width: 100%; margin-top: 8px" placeholder="Please specify"
                    @input="onSubmissionPurposeOtherInput" />
                  <label v-if="project.readonly">{{ project.submissionPurpose }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="proponent" style="width: 100%">*Project Proponent:</label>
                  <InputText v-if="!project.readonly" v-model="project.proponent" aria-label="Project Proponent"
                    style="width: 100%" />
                  <label v-else>{{ project.proponent }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="agreement" style="width: 100%">*Contract / Agreement:</label>
                  <InputText v-if="!project.readonly" v-model="project.agreement" aria-label="Contract / Agreement"
                    style="width: 100%" />
                  <label v-else>{{ project.agreement }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="mainContractor" style="width: 100%">*Main Contractor:</label>
                  <InputText v-if="!project.readonly" v-model="project.mainContractor" aria-label="Main Contractor"
                    style="width: 100%" />
                  <label v-else>{{ project.mainContractor }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="engineerConsultant" style="width: 100%">*Engineer Consultant:</label>
                  <InputText v-if="!project.readonly" v-model="project.engineerConsultant"
                    aria-label="Engineer Consultant" style="width: 100%" />
                  <label v-else>{{ project.engineerConsultant }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="bufferRadius" style="width: 100%">*Radius of Assessment Area (m):</label>
                  <InputNumber v-if="!project.readonly" v-model="project.bufferRadius"
                    aria-label="Radius of Assessment Area" style="width: 100%" />
                  <label v-else>{{ project.bufferRadius }}</label>
                </div>
                <div class="field col-12 md:col-4" v-if="project.tasks.length > 0">
                  <label for="commencementDate" style="width: 100%">*Commencement Date:</label>
                  <!-- <Calendar v-if="!project.readonly" id="commencementDate"
                                                                                                                                                                                                        v-model="project.commencementDate" :showIcon="true" class="w-full"
                                                                                                                                                                                                        dateFormat="yy-mm-dd" :maxDate="getDate(project.completionDate)" /> -->
                  <label>{{ project.commencementDate }}</label>
                </div>
                <div class="field col-12 md:col-4" v-if="project.tasks.length > 0">
                  <label for="completionDate" style="width: 100%">*Expected Completion Date:</label>
                  <!-- <Calendar v-if="!project.readonly" id="completionDate"
                                                                                                                                                                                                v-model="project.completionDate" :showIcon="true" class="w-full"
                                                                                                                                                                                                dateFormat="yy-mm-dd" :minDate="getDate(project.commencementDate)" /> -->
                  <label>{{ project.completionDate }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="bufferRadius" style="width: 100%">*District:</label>
                  <!-- <Dropdown v-if="!project.readonly || MapOL.getSiteDistrict()"
                                        v-model="project.targetDistrict" :options="['Central & Western',
                                            'Wan Chai',
                                            'Eastern',
                                            'Southern',
                                            'Yau Tsim Mong',
                                            'Sham Shui Po',
                                            'Kowloon City',
                                            'Wong Tai Sin',
                                            'Kwun Tong',
                                            'Kwai Tsing',
                                            'Tsuen Wan',
                                            'Tuen Mun',
                                            'Yuen Long',
                                            'North',
                                            'Tai Po',
                                            'Sha Tin',
                                            'Sai Kung',
                                            'Islands']" style="height: 30px;width:100%">
                                    </Dropdown>
                                    <label v-else>{{ project.targetDistrict }}</label> -->
                  <label>{{ project.targetDistrict }}</label>
                </div>
                <div class="field col-12 md:col-4">
                  <label for="eiaReference" style="width: 100%">EIA Reference:</label>
                  <InputText v-if="!project.readonly" v-model="project.eiaReference" style="width: 100%"
                    aria-label="EIA Reference" />
                  <label v-else>{{ project.eiaReference }}</label>
                </div>
                <div class="field col-12">
                  <label for="description" style="width: 100%">Project Desciption:</label>
                  <textarea v-if="!project.readonly" id="description" style="font-family: 'Times New Roman' !important"
                    v-model="project.description" aria-label="Project Description" type="text" rows="2"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"></textarea>
                  <label v-else>{{ project.description }}</label>
                </div>
                <div class="field col-12">
                  <label for="specialFeature" style="width: 100%">Special Features:</label>
                  <InputText v-if="!project.readonly" v-model="project.specialFeature" aria-label="Special Features"
                    style="width: 100%" />
                  <label v-else>{{ project.specialFeature }}</label>
                </div>
                <!-- <div class="field col-12">
                                    <div class="field-checkbox">
                                        <Checkbox inputId="neighbor" v-model="project.hasNeighbors" :binary="true"
                                            v-if="!project.readonly">
                                        </Checkbox> <label for="neighbor" style="width:100%">Concurrent
                                            Sites</label>
                                    </div>
                                    <div v-if="project.hasNeighbors || project.unregisteredNeighbours.length > 0"
                                        class="formgrid grid">
                                        <div class="field col-12 md:col-4" v-if="!project.readonly">
                                            <InputText v-if="!project.readonly" v-model="unregSiteName" style="width:100%"
                                                placeholder="Project Name" />
                                        </div>
                                        <div class="field col-12 md:col-2" v-if="!project.readonly">
                                            <Button icon="pi pi-plus" :icon="slotProps.data.deleting"
                                                class="p-button-rounded p-button-secondary p-button-text"
                                                @click="project.unregisteredNeighbours.push({ name: unregSiteName, id: project.unregisteredNeighbours.length + 1, projectId: project.id }); unregSiteName = ''"
                                                v-tooltip="'Add Project'" />
                                        </div>
                                        <div class="field col-12 md:col-6"></div>
                                        <div class="field col-12 md:col-6">
                                            <DataTable :value="project.unregisteredNeighbours"
                                                v-if="project.unregisteredNeighbours.length > 0"
                                                class="p-datatable-sm field col-12 md:col-5" :scrollable="true"
                                                scrollHeight="300px" style="width:100%">
                                                <Column field="name" header="Project Name" style="min-width:90%">
                                                </Column>
                                                <Column style="width:5%" v-if="!project.readonly">
                                                    <template #body="slotProps">
                                                        <Button icon="pi pi-times" :icon="slotProps.data.deleting"
                                                            class="p-button-rounded p-button-secondary p-button-text p-button-danger"
                                                            @click="" v-tooltip="'Delete'" />
                                                    </template>
                                                </Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div> -->
                <div class="field col-12">* Mandatory field</div>
              </div>
            </ScrollPanel>
          </TabPanel>
          <TabPanel header="Zone" :disabled="checkInfo || projectTitleExists">
            <template #header>
              <i class="pi pi-question-circle" style="padding-left: 5px"
                v-tooltip="'Define the site and zone geography'"></i>
            </template>
            <ScrollPanel class="contentPanel">
              <label class="field col-12 md:col-10 fieldLabel">
                Click the draw button on the left to define the site. Then click the draw button on the right to define
                the zones
                within the site. Or
                user can upload zip file of site polygon in
                <span style="color: red"><b>Shapefile format (EPSG:3857 WGS 1984 Auxiliary Sphere), with Z and M values
                    disabled</b></span>.
              </label>
              <div class="formgrid grid" v-if="!project.readonly">
                <!-- <div class="field col-12 md:col-4 fieldLabel">
                                                                                                                                                                                                                                                                                                <div class="verticalBoxContainer"> -->

                <label for="drawbutton" class="field col-12 md:col-2 fieldLabel">1. Define site:</label>
                <Button id="drawbutton" label="Draw" icon="pi pi-pencil" @click="switchSiteDraw"
                  class="field col-12 md:col-3" :disabled="isSaving" />
                <div class="field col-12 md:col-2 fieldLabel"></div>
                <label for="drawbutton2" class="field col-12 md:col-2 fieldLabel">2. Define zones:</label>
                <Button id="drawbutton2" label="Draw" icon="pi pi-pencil" @click="switchZoneCutterDraw"
                  class="field col-12 md:col-3" :disabled="isSaving" />

                <div class="field col-12 md:col-2 fieldLabel"></div>
                <div class="field col-12 md:col-3 fieldLabel" style="padding: 0px">
                  <UploadFile @upload="uploadFileSite" :label="shpfileName" format=".zip" style="height: 30px"
                    id="selectShapeFile" :multiple="false" :disabled="isSaving">
                  </UploadFile>
                </div>
                <div class="field col-12 md:col-4 fieldLabel"></div>
                <div class="field col-12 md:col-3 fieldLabel" style="padding: 0px">
                  <UploadFile @upload="uploadFileZone" :label="shpzonefileName" format=".zip" style="height: 30px"
                    id="selectZoneShapeFile" :multiple="false" :disabled="isSaving">
                  </UploadFile>
                </div>

                <div class="field col-12 md:col-2 fieldLabel"></div>
              </div>
              <div class="formgrid grid">
                <div class="field col-12 fieldLabel" v-if="project.zones.length > 0">
                  <DataTable :value="project.zones" class="p-datatable-sm" :scrollable="true" editMode="cell"
                    @cell-edit-complete="onZoneEditComplete" scrollHeight="350px" sortField="id" :sortOrder="1">
                    <Column field="id" header="Zone" style="max-width: 10%" :sortable="true"> </Column>
                    <Column field="name" header="Name" :sortable="true">
                      <template #editor="{ data, field }">
                        <InputText type="text" v-model="data[field]" autofocus />
                      </template>
                    </Column>
                    <Column field="calculationtype" header="Noise Contribution from Zones" :sortable="true">
                      <template #editor="{ data, field }">
                        <!-- <InputText type="text" v-model="data[field]" autofocus /> -->
                        <Dropdown v-model="data[field]" :options="typeOptions" optionLabel="label"
                          optionValue="value" />
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
              <div class="formgrid grid">
                <div class="field col-12 fieldLabel">
                  <h2 style="text-align: center; color: #424447; width: 60%; margin: auto">
                    Note: If the zone area is linear in shape (that is long and thin and substantially uniform in width,
                    but not
                    necessarily straight)
                    with a length to width ratio exceeding 5:1, please split the zone area into smaller section(s), so
                    that the
                    length to width ratio
                    is less than 5:1 as per Section 2.7 of the Technical Memorandum on Noise from Construction Work
                    other than
                    Percussive Piling.
                  </h2>
                </div>
              </div>
            </ScrollPanel>
          </TabPanel>
          <TabPanel header="Schedule" :disabled="checkInfo || projectTitleExists">
            <template #header>
              <i class="pi pi-question-circle" style="padding-left: 5px"
                v-tooltip="'Define construction activity schedule'"></i>
            </template>
            <ScrollPanel class="contentPanel">
              <div class="formgrid grid" v-if="!project.readonly">
                <div v-show="showImport" class="field col-12">
                  <div class="formgrid grid">
                    <label class="field col-12 fieldLabel p-error" v-if="project.zones.length == 0"
                      id="password-help">Please
                      define project zone first.</label>
                    <div class="field col-12 fieldLabel">
                      <label style="font-weight: bold">Import from Template</label><i class="pi pi-question-circle"
                        v-tooltip="'Download the CSV Template and edit it. Upload the edited file using the button on the right'"></i>
                    </div>
                    <label class="field col-12 md:col-2 fieldLabel">1. Download Template:</label>
                    <!-- <Dropdown class="field col-12 md:col-3 fieldLabel" v-model="selectedTemplate"
                                                                                                                                                                                                                                                                                                        :options="['CSV Template']" placeholder="Select a Template"
                                                                                                                                                                                                                                                                                                        style="height:30px" @change="downloadTemplate">
                                                                                                                                                                                                                                                                                                    </Dropdown> -->
                    <Button class="field col-12 md:col-2" label="Download CSV Template" icon="pi pi-download"
                      @click="downloadTemplate" style="height: 30px"></Button>
                    <div class="field col-12 md:col-1"></div>
                    <div class="field col-12 md:col-2 fieldLabel">2. Upload & Import:</div>
                    <div class="field col-12 md:col-5" style="padding: 0">
                      <div class="formgrid grid">
                        <div style="height: 30px; width: calc(100% - 205px)">
                          <UploadFile @upload="uploadFile" :label="fileName" format=".csv" style="height: 30px"
                            id="uploadSchedule" multiple="">
                          </UploadFile>
                        </div>
                        <div style="width: 205px">
                          <Button id="importSchedule" label="Import from Template" icon="pi pi-download"
                            @click="confirmOverwriteProject($event)" :disabled="file == null" :icon="importing"
                            style="float: right; height: 30px; width: 200px"></Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Divider align="center">
                  <Button v-if="showImport" icon="pi pi-angle-double-up" aria-label="Hide Import from Template"
                    class="p-button-rounded p-button-outlined" @click="showImport = false"></Button>
                  <Button v-else icon="pi pi-angle-double-down" class="p-button-rounded p-button-outlined"
                    aria-label="Show Import from Template" @click="showImport = true"></Button>
                </Divider>
                <div class="field col-12 fieldLabel" style="margin-bottom: 0">
                  <label style="font-weight: bold">Add Activity in Table below</label>
                  <i class="pi pi-question-circle" style="padding-left: 5px" v-tooltip="'Fill in the construction work name, activity name, and activity duration. Click the Add Activity button to add the activity to the table.'
                    "></i>
                </div>
                <div class="field col-12">
                  <Schedule v-if="project.zones.length > 0" style="max-width: 100%" :tasks="project.tasks"
                    :zones="project.zones.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }))"
                    :groups="groups" :constructionWorks="constructionWorks" :activities="activities"
                    @setTasks="setTasks" @addTask="addTask" @setSelectedZone="setSelectedZone"
                    @updateEquipmentGroup="updateEquipmentGroup" ref="scheduleRef" :readonly="project.readonly"
                    :projectStart="project.commencementDate" :projectEnd="project.completionDate"
                    :selectedZone="selectedZone" @openCWAct="openCWAct" :projectId="getProjectId()" />
                </div>
              </div>
              <div class="formgrid grid" v-else>
                <div class="field col-12">
                  <Schedule v-if="project.zones.length > 0" style="max-width: 100%" :tasks="project.tasks"
                    :zones="project.zones.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }))"
                    :groups="groups" :projectStart="project.commencementDate" :projectEnd="project.completionDate"
                    :constructionWorks="constructionWorks" :activities="activities" @setTasks="setTasks"
                    @addTask="addTask" ref="scheduleRef" :readonly="project.readonly" :selectedZone="selectedZone"
                    :projectId="getProjectId()" />
                </div>
              </div>
            </ScrollPanel>
          </TabPanel>
          <!-- <TabPanel header="Unregistered Neighbour Sites" v-if="!project.readonly">
                        <ScrollPanel class="contentPanel">
                            <div class="formgrid grid">
                                <label class="field col-12 md:col-12 fieldLabel">Add new unregistered site:</label>

                                <label for="affectCombo" class="field col-12 md:col-4 fieldLabel">Degree at which the
                                    NSR is affected by noise:</label>
                                <div class="field col-12 md:col-1 fieldLabel"></div>
                                <label for="radiusBox" class="field col-12 md:col-2 fieldLabel">Unregstered site
                                    radius:</label>
                                <div class="field col-12 md:col-2 fieldLabel"></div>
                                <label for="drawunregbutton" class="field col-12 md:col-3 fieldLabel">Define
                                    site:</label>
                                <Dropdown id="affectCombo" v-model="unregSiteAffectDegree"
                                    :options="['Slightly Affected', 'Affected']" placeholder="Select a degree"
                                    class="field col-12 md:col-4 fieldLabel">
                                </Dropdown>
                                <div class="field col-12 md:col-1 fieldLabel"></div>
                                <input id="radiusBox" v-model="unregSiteRadus" type="number"
                                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary field col-12 md:col-2 fieldLabel">
                                <div class="field col-12 md:col-2 fieldLabel"></div>
                                <Button id="drawunregbutton" label="Draw" icon="pi pi-pencil"
                                    class="field col-12 md:col-3 fieldLabel" @click="switchUnregSiteDraw" />
                            </div>
                        </ScrollPanel>
                    </TabPanel> -->
        </TabView>
      </template>
      <template #footer>
        <div class="formgrid grid">
          <div class="field col-12 md:col-6" v-if="activeIndex === 0"></div>
          <div class="field col-12 md:col-6" v-if="activeIndex > 0">
            <Button class="p-button-secondary" label="Back" icon="pi pi-angle-left" style="float: left"
              @click="prevPage" />
          </div>
          <div class="field col-12 md:col-5" v-if="activeIndex < 2 && !project.readonly">
            <Button label="Save" :icon="savingProject" style="float: right" @click="saveProject(false)"
              :disabled="checkInfo || projectTitleExists || isSaving" />
          </div>
          <div class="field col-12 md:col-4" v-if="activeIndex === 2 && !project.readonly">
            <Button label="Save" :icon="savingProject" style="float: right" @click="saveProject(false)"
              :disabled="checkInfo || projectTitleExists || isSaving" />
          </div>
          <div class="field col-12 md:col-1" v-if="activeIndex < 2 && !project.readonly">
            <Button label="Next" icon="pi pi-angle-right" style="float: right" @click="nextPage"
              :disabled="checkInfo || projectTitleExists || isSaving" />
          </div>
          <div class="field col-12 md:col-6" v-if="activeIndex < 2 && project.readonly">
            <Button label="Next" icon="pi pi-angle-right" style="float: right" @click="nextPage"
              :disabled="checkInfo || projectTitleExists || isSaving" />
          </div>
          <div class="field col-12 md:col-2" v-if="activeIndex === 2 && !project.readonly">
            <Button label="Save and Finish" :icon="savingProject2" style="float: right"
              :disabled="checkInfo || projectTitleExists || isSaving" @click="saveProject(true)" />
          </div>
          <div class="field col-12 md:col-6" v-if="activeIndex === 3 && !project.readonly">
            <Button label="Save Unregistered Sites" :icon="savingProject" style="float: right"
              :disabled="checkInfo || projectTitleExists || isSaving" @click="saveUnregSites" />
          </div>
        </div>
        <!-- <div class="formgrid grid">
                                                                                                                                                                                                                                                                            </div> -->
      </template>

      <!--<h5 style="margin: 0px;">New Project</h5>
                                                                                                                                                                                                                                                                        <Button icon="pi pi-arrows-v" style="position: absolute; top: 0px; right: 0px;" @click="switchPanel" />-->
    </Card>
  </div>
  <div class="minimizeWindow" v-show="siteDrawMode">
    <Card>
      <template #title>
        Define Site & Zone
        <i class="pi pi-question-circle" style="padding-left: 5px"
          v-tooltip="'Click on the map to draw lines. Click Save to save then click the icon on the top right to return to the previous window'"></i>
        <Button icon="pi pi-window-maximize" class="p-button-rounded p-button-secondary p-button-text"
          style="position: fixed; right: 10px" @click="exitDrawMode" aria-label="Maximize Window"
          v-tooltip="'Return to the previous window'" />
      </template>
      <template #content>
        <div class="formgrid grid">
          <!-- <div class="field col-12 md:col-4 fieldLabel">
                                                                                                                                                                                                                                                                                                <div class="verticalBoxContainer"> -->
          <label for="site" class="field col-12 md:col-1 fieldLabel">Site:</label>
          <Button id="site" label="Draw" icon="pi pi-pencil" @click="switchSiteDraw" class="field col-12 md:col-1"
            style="margin-right: 5px" :disabled="isSaving" />
          <Button id="site-clear" label="Clear" icon="pi pi-trash" @click="clearSiteDraw" class="field col-12 md:col-1"
            style="margin-right: 10px" :disabled="isSaving" />
          <label for="zone" class="field col-12 md:col-1 fieldLabel" style="margin-right: -10px">Zones:</label>
          <Button id="zone" label="Draw" icon="pi pi-pencil" @click="switchZoneCutterDraw" class="field col-12 md:col-1"
            style="margin-right: 5px" :disabled="isSaving" />
          <Button id="zone-clear" label="Clear" icon="pi pi-trash" @click="clearZoneDraw" class="field col-12 md:col-1"
            style="margin-right: 5px" :disabled="isSaving" />
          <Dropdown class="field col-12 md:col-5" v-model="importZoneName" :options="importZoneNameFieldOptions"
            placeholder="Select zone name field from shapefile" @change="zoneNameFieldChange" />
          <label for="radius" class="field col-12 md:col-3 fieldLabel" style="margin-right: 5px">Radius of Assessment
            Area (m):</label>
          <InputNumber v-if="!project.readonly" aria-label="Radius of Assessment Area (m)"
            v-model="project.bufferRadius" class="field col-12 md:col-1" />
          <Button id="radius-inc" icon="pi pi-plus" @click="
            project.bufferRadius += 50;
          updateBuffer();
          " class="field col-12 md:col-1" aria-label="Increase" style="margin-right: 5px" :disabled="isSaving" />
          <Button id="radius-dec" icon="pi pi-minus" @click="
            project.bufferRadius -= 50;
          updateBuffer();
          " class="field col-12 md:col-1" style="margin-right: 5px" aria-label="Decrease"
            :disabled="project.bufferRadius == 0 || isSaving" />
          <Button id="radius-update" label="Update Assessment Area" icon="pi pi-pencil" @click="updateBuffer"
            class="field col-12 md:col-3" style="margin-right: 5px" :disabled="isSaving" />
          <Button label="Save" :icon="savingProject" @click="saveProject(false)" class="field col-12 md:col-1"
            style="margin-right: 5px" :disabled="isSaving" />
          <Button label="Next" icon="pi pi-angle-right" style="float: right" @click="
            exitDrawMode();
          nextPage();
          " :disabled="checkInfo || projectTitleExists || isSaving" class="field col-12 md:col-1" />
          <label v-if="message" class="field col-12 md:col-12" style="color: red">{{ message }}</label>
        </div>
      </template>
    </Card>
  </div>
  <div class="minimize" v-show="unregSiteDrawMode">
    <Card style="height: 14vh">
      <template #title>
        Define Unregistered Site
        <Button icon="pi pi-window-maximize" class="p-button-rounded p-button-secondary p-button-text"
          style="position: fixed; right: 10px" @click="exitUnregDrawMode" />
      </template>
      <template #content>
        <div class="formgrid grid">
          <!-- <div class="field col-12 md:col-4 fieldLabel">
                                                                                                                                                                                                                                                                                                <div class="verticalBoxContainer"> -->
          <label for="unregsite" class="field col-12 md:col-2 fieldLabel">Unregistered site:</label>
          <Button id="unregsite" label="Draw" icon="pi pi-pencil" @click="switchUnregSiteDraw"
            class="field col-12 md:col-2 fieldLabel" />
          <Button id="unregsite-clear" label="Clear" icon="pi pi-trash" @click="clearUnregSiteDraw"
            class="field col-12 md:col-2 fieldLabel" />
          <div class="field col-12 md:col-6 fieldLabel"></div>
        </div>
      </template>
    </Card>
  </div>
  <div class="target" v-if="showCWAct">
    <Card>
      <template #title>
        Import from Construction Work Activities
        <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
          style="position: fixed; right: 10px" @click="showCWAct = false" />
      </template>

      <template #content>
        <div class="field col-12 fieldLabel">
          <div class="formgrid grid">
            <div class="field col-12 fieldLabel">
              <label style="font-weight: bold">Import from Construction Work Activities</label><i
                class="pi pi-question-circle"
                v-tooltip="'Select and import construction works and activities to create schedule'"></i>
            </div>
            <label class="field col-12 md:col-1 fieldLabel">Zone<i class="pi pi-question-circle"
                style="padding-left: 5px" v-tooltip="'Select zone to import works and activities​'"></i></label>
            <Dropdown class="field col-12 md:col-3 fieldLabel" v-model="selectedZone" :options="project.zones"
              optionLabel="name" style="height: 27.5px" @change="filterTasks(selectedZone)">
            </Dropdown>
            <div class="field col-12 md:col-8 fieldLabel"></div>
            <label class="field col-12 md:col-2 fieldLabel">Construction Works:</label>
            <div class="field col-12 md:col-3 fieldLabel"></div>
            <label class="field col-12 md:col-2 fieldLabel">Activities:</label>
            <div class="field col-12 md:col-3 fieldLabel"></div>
            <div class="field col-12 md:col-2 fieldLabel">
              <Button label="Clear All" icon="pi pi pi-refresh" @click="selectedActivities = []"
                style="float: right; height: 30px"></Button>
            </div>
            <Listbox class="field col-12 md:col-5 fieldLabel" aria-label="Construction Works" v-model="selectedCw"
              :options="cwActs" optionLabel="name" listStyle="max-height:222px" @change="
                groupName = selectedCw ? (selectedCw.name != 'All' ? selectedCw.name : '') : '';
              selectedActivities = [];
              " id="cwlist" style="max-height: 222px">
            </Listbox>
            <Listbox class="field col-12 md:col-7 fieldLabel" v-model="selectedActivities" aria-label="Activities"
              :options="selectedCw ? selectedCw.activities : []" multiple="multiple" listStyle="max-height:222px"
              id="aclist" style="max-height: 222px">
            </Listbox>
            <div class="field col-12 md:col-2 fieldLabel">
              <label>Custom Construction Work Name</label><i class="pi pi-question-circle"
                v-tooltip="'Create your custom construction work'"></i>
            </div>
            <InputText type="text" class="field col-12 md:col-3 fieldLabel" v-model="groupName" />
            <div class="field col-12 md:col-2 fieldLabel">
              <label>Construction Work Duration</label><i class="pi pi-question-circle"
                v-tooltip="'Define start and end dates for your construction work'"></i>
            </div>
            <Calendar class="field col-12 md:col-3 fieldLabel" v-model="groupDuration" showIcon="true"
              dateFormat="yy-mm-dd" selectionMode="range" />
            <div class="field col-12 md:col-2 fieldLabel">
              <Button id="importActivities" label="Add Activity" icon="pi pi-download" @click="importActivities"
                :disabled="selectedActivities.length == 0" style="float: right; height: 30px"></Button>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
  <ConfirmPopup> </ConfirmPopup>
  <!-- <Moveable className="moveable" v-bind:target="['.target']" v-bind:draggable="true" @drag="onDrag" /> --><!--</div>-->
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import Moveable from "vue3-moveable";
import Schedule from "@/components/schedule module/Schedule.vue";
import UploadFile from "@/components/UploadFile.vue";
import DateHelper from "@/helper/DateHelper";
import { ref, reactive } from "vue";
import Papa from "papaparse";

export default {
  name: "ProjectDialog",
  props: {
    projects: Object,
    project: Object,
    newProject: Boolean,
  },
  components: {
    Moveable,
    Schedule,
    UploadFile,
  },
  setup() {
    const scheduleRef = ref();
    const filterTasks = (taskChanged, tasks) => {
      scheduleRef.value?.filterTasks(taskChanged, tasks);
    };

    return {
      filterTasks,
      scheduleRef,
    };
  },
  data() {
    return {
      selectedTemplate: "CSV Template",

      districtOptions: [
        { label: "Central & Western", value: "Central & Western" },
        { label: "Eastern", value: "Eastern" },
        { label: "Islands", value: "Islands" },
        { label: "Kowloon City", value: "Kowloon City" },
        { label: "Kwai Tsing", value: "Kwai Tsing" },
        { label: "Kwun Tong", value: "Kwun Tong" },
        { label: "North", value: "North" },
        { label: "Sai Kung", value: "Sai Kung" },
        { label: "Sham Shui Po", value: "Sham Shui Po" },
        { label: "Sha Tin", value: "Sha Tin" },
        { label: "Southern", value: "Southern" },
        { label: "Tai Po", value: "Tai Po" },
        { label: "Tsuen Wan", value: "Tsuen Wan" },
        { label: "Tuen Mun", value: "Tuen Mun" },
        { label: "Wan Chai ", value: "Wan Chai" },
        { label: "Wong Tai Sin", value: "Wong Tai Sin" },
        { label: "Yau Tsim Mong", value: "Yau Tsim Mong" },
        { label: "Yuen Long", value: "Yuen Long" },
      ],

      typeOptions: [
        { label: "A - General Construction Site – noise contribution from all zones of this type are added together at NSRs", value: "A" },
        {
          label:
            "B - Dominant Portion only – Only the zone nearest to the NSR is considered. For works carried out zone by zone repeatedly but not simultaneously (e.g. road work or pipe laying work)",
          value: "B",
        },
      ],
      submissionPurposeOptions: [
        {
          label: "Statutory (EP Condition)",
          description:
            "Submission required under Environmental Permit (EP) condition. Mandatory for regulatory compliance under the Environmental Impact Assessment Ordinance.",
        },
        {
          label: "Non-Statutory (PER Commitment)",
          description: "Submission as a follow-up to commitments made in a Preliminary Environmental Review (PER).",
        },
        {
          label: "Voluntary (BEAM Plus Bonus Credits)",
          description:
            "Voluntary submission to obtain BEAM Plus additional bonus credits [EPD's comment on the submission is not required]",
        },
        {
          label: "Others",
          description: "For submissions that do not fall into the above categories. Please specify",
        },
      ],
      selectedSubmissionPurpose: "",
      submissionPurposeOther: "",
      calculationType: "Center",

      cwActs: [],
      selectedCw: "",
      selectedActivities: [],
      groupName: "",
      groupDuration: [new Date(), new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())],

      constructionWorks: [],

      activities: [],

      panelHeight: "500px",

      importing: "",
      showImport: true,
      showImport2: true,
      file: null,
      fileName: "Upload",
      groups: reactive([]),

      shpfileName: "Upload site shapefile in zip format",
      shpzonefileName: "Upload zone shapefile in zip format",

      siteDrawMode: false,
      unregSiteDrawMode: false,

      activeIndex: 0,

      savingProject: "pi pi-save",
      savingProject2: "pi pi-save",
      isSaving: false,

      unregSiteName: "",
      unregSiteAffectDegree: "",
      unregSiteRadus: 300,

      selectedZone: this.project.zones.sort((a, b) => (a.name > b.name ? 1 : -1))[0],

      showCWAct: false,

      importZoneName: "",
      importZoneNameFieldOptions: [],

      oldZones: [],

      message: "",

      showTypingError: false,
    };
  },
  computed: {
    computedHeight() {
      return this.panelHeight;
    },
    checkInfo() {
      let check = !(
        this.project.projectTitle &&
        this.project.proponent &&
        this.project.agreement &&
        this.project.mainContractor &&
        this.project.engineerConsultant &&
        // this.project.commencementDate &&
        // this.project.completionDate &&
        this.project.bufferRadius
      );
      return check;
    },
    projectTitleExists() {
      let props = this;
      return this.projects
        ? this.projects.filter((p) => p.projectTitleWithoutVersion?.trim() == props.project.projectTitle?.trim()).length > 0 && !props.project.id
        : false;
    },
    getSiteDistrict() {
      return MapOL.getSiteDistrict();
    },
    submissionPurposeTooltip() {
      return this.submissionPurposeOptions.map((opt) => `${opt.label}: ${opt.description}`).join("\n\n");
    },
  },
  methods: {
    initializeSubmissionPurpose() {
      const existingValue = this.project.submissionPurpose || "";
      const labels = this.submissionPurposeOptions.map((opt) => opt.label);

      if (labels.includes(existingValue)) {
        this.selectedSubmissionPurpose = existingValue;
        this.submissionPurposeOther = "";
        return;
      }

      if (existingValue.startsWith("Others:")) {
        this.selectedSubmissionPurpose = "Others";
        this.submissionPurposeOther = existingValue.replace("Others:", "").trim();
        return;
      }

      if (existingValue) {
        this.selectedSubmissionPurpose = "Others";
        this.submissionPurposeOther = existingValue;
        this.project.submissionPurpose = `Others: ${existingValue}`;
        return;
      }

      this.selectedSubmissionPurpose = "";
      this.submissionPurposeOther = "";
    },
    onSubmissionPurposeChange() {
      if (this.selectedSubmissionPurpose === "Others") {
        this.project.submissionPurpose = this.submissionPurposeOther ? `Others: ${this.submissionPurposeOther}` : "Others";
      } else {
        this.submissionPurposeOther = "";
        this.project.submissionPurpose = this.selectedSubmissionPurpose;
      }
    },
    onSubmissionPurposeOtherInput(e) {
      const inputValue = e && e.target ? e.target.value : this.submissionPurposeOther;
      this.submissionPurposeOther = inputValue;
      this.project.submissionPurpose = inputValue ? `Others: ${inputValue}` : "Others";
    },
    syncSubmissionPurposeForSave() {
      if (this.selectedSubmissionPurpose === "Others") {
        this.project.submissionPurpose = this.submissionPurposeOther ? `Others: ${this.submissionPurposeOther}` : "Others";
      } else {
        this.project.submissionPurpose = this.selectedSubmissionPurpose || "";
      }
    },
    onProjectTitleInput(e) {
      // Remove all '@' characters from the input
      if (e && e.target && e.target.value) {
        this.project.projectTitle = e.target.value.replace(/@/g, "");
      }
    },
    close() {
      DateHelper.fixUTCDate(this.project);
      this.savingProject = "pi pi-save";
      this.$router.replace({ path: "/" });
    },
    nextPage() {
      DateHelper.fixUTCDate(this.project);
      this.activeIndex = this.activeIndex + 1;
    },
    prevPage() {
      DateHelper.fixUTCDate(this.project);
      this.activeIndex = this.activeIndex - 1;
      this.updateProjectDate();
    },
    getUser() {
      return this.$store.getters.currentUser;
    },
    getUserName() {
      return `${this.$store.getters.currentUser.firstName} ${this.$store.getters.currentUser.lastName}`;
    },
    getProjectId() {
      return this.$store.getters.ProjectId;
    },
    saveProject(close) {
      this.isSaving = true;
      this.updateProjectDate();
      if (close) {
        this.savingProject2 = "pi pi-spin pi-spinner";
      } else {
        this.savingProject = "pi pi-spin pi-spinner";
      }
      let props = this;
      this.syncSubmissionPurposeForSave();
      this.project.calculationtype = this.calculationType;
      this.project.targetDistrict = MapOL.getSiteDistrict() || this.project.targetDistrict;
      this.project.ownerUserId = this.project.ownerUserId ? this.project.ownerUserId : this.getUser().id;
      this.project.ownerCompany = this.project.ownerCompany ? this.project.ownerCompany : this.getUser().company;
      this.project.owner = this.project.owner ? this.project.owner : this.getUserName();
      this.project.updatedBy = this.getUserName();
      this.project.submitted = false;
      this.project.selectednsr = MapOL.getSelectedNSRPointIds().join(",");
      if (MapOL.getIsMultipolygon()) {
        this.project.ismultipolygon = 1;
      } else {
        this.project.ismultipolygon = 0;
      }
      console.log("this.project.ismultipolygon", this.project.ismultipolygon);
      const zoneTaskIds = this.project.tasks.map((t) => `${t.zone}-${t.id}`);
      this.project.tasks.forEach((t) => {
        if (!t.start && !t.end) {
          t.start = DateHelper.getDateString(new Date());
          t.end = DateHelper.getDateString(new Date());
        }
        if (t.end == null || !t.end) {
          t.end = t.start;
        }
        if (t.start == null || !t.start) {
          t.start = t.end;
        }
      });
      this.project.equipments = this.project.equipments.filter((e) => zoneTaskIds.includes(`${e.zone}-${e.task}`));
      //remove equipments to avoid circular structure error when saving project, equipments will be saved separately in backend;
      let projectCopied = { ...props.project, equipments: [] };
      if (projectCopied.calculationResultNSR) {
        delete projectCopied.calculationResultNSR;
      }
      if (!props.project.id) {
        props.axios
          .post(`${props.apiEndpoint}project`, DateHelper.fixUTCDate(projectCopied))
          .then(function (response) {
            let savedProject = { ...response.data, equipments: props.project.equipments };
            console.log(savedProject);
            savedProject = DateHelper.fixUTCDate(savedProject);
            props.$store.dispatch("addeNewProject", { project: savedProject });
            props.$store.dispatch("setCurrentProject", { project: savedProject });
            props.$store.commit("setProjectId", { value: savedProject.id });
            console.log("this projectid = ", savedProject.id);
            const projectWithGroups = props.initGroups(savedProject);
            props.$store.dispatch("setCurrentProject", { project: projectWithGroups });
            MapOL.saveProjectGISData(savedProject.id, savedProject.zones, close, function () {
              props.savingProject = "pi pi-save";
              props.savingProject2 = "pi pi-save";
              props.project.id = savedProject.id;
              props.isSaving = false;
              if (close) {
                props.close();
              }
            });
          })
          .catch((error) => console.log(error));
      } else {
        props.axios
          .post(`${props.apiEndpoint}project?id=${props.project.id}`, DateHelper.fixUTCDate(projectCopied))
          .then(function (response) {
            let savedProject = { ...response.data, equipments: props.project.equipments };
            savedProject = DateHelper.fixUTCDate(savedProject);
            props.$store.dispatch("setCurrentProject", { project: savedProject });
            props.$store.commit("setProjectId", { value: savedProject.id });
            console.log("this projectid = ", savedProject.id);
            console.log(savedProject);
            console.log("zones from NOT newproject:");
            console.log(savedProject.zones);
            const projectWithGroups = props.initGroups(savedProject);
            props.$store.dispatch("setCurrentProject", { project: projectWithGroups });
            MapOL.saveProjectGISData(savedProject.id, savedProject.zones, close, function () {
              props.savingProject = "pi pi-save";
              props.savingProject2 = "pi pi-save";
              props.isSaving = false;
              if (close) {
                props.close();
              }
            });
          })
          .catch((error) => console.log(error));
      }
    },
    saveUnregSites() {
      MapOL.saveUnregSitesGISData(this.project.id);
    },
    minimizeWin() {
      this.siteDrawMode = true;
    },
    switchPanel() {
      if (this.panelHeight === "500px") {
        this.panelHeight = "100px";
      } else {
        this.panelHeight = "500px";
      }
    },
    switchSiteDraw() {
      MapOL.switchOffCutterLineDraw();
      MapOL.switchOnSiteDraw(this.project.bufferRadius);
      this.project.zones = [];
      this.siteDrawMode = true;
      for (var i = this.project.zones.length; i < 1; i++) {
        this.project.zones.push({
          id: i + 1,
          name: `Zone ${i + 1}`,
          calculationtype: "A",
          // startDate: '-',
          // endDate: '-'
        });
      }
    },
    switchUnregSiteDraw() {
      if (this.unregSiteAffectDegree === "") {
        alert("Please input the noise degree of affect to the construction site.");
        return;
      }
      MapOL.switchOnUnregSiteDraw(this.unregSiteRadus, this.unregSiteAffectDegree);
      this.unregSiteDrawMode = true;
    },
    updateBuffer() {
      let props = this;
      MapOL.updateBuffer(this.project.bufferRadius).then((message) => {
        props.message = message;
      });
    },
    clearSiteDraw() {
      MapOL.clearSiteDraw();
      this.project.zones = [];
    },
    clearUnregSiteDraw() {
      MapOL.clearUnregSiteDraw();
    },
    switchZoneCutterDraw() {
      MapOL.switchOffSiteDraw();
      let props = this;
      MapOL.switchOnCutterLineDraw(function (zoneCount) {
        if (props.project.zones.length > zoneCount) {
          props.project.zones = props.project.zones.slice(0, zoneCount);
        } else {
          for (var i = props.project.zones.length; i < zoneCount; i++)
            props.project.zones.push({
              id: i + 1,
              name: `Zone ${i + 1}`,
              calculationtype: "A",
              // startDate: '-',
              // endDate: '-'
            });
        }
      });
      this.siteDrawMode = true;
    },
    clearZoneDraw() {
      MapOL.clearZoneDraw();
      this.project.zones = [this.project.zones[0]];
    },
    switchZoneOrderDraw() {
      MapOL.switchZoneOrderDraw();
      this.siteDrawMode = true;
    },
    exitDrawMode() {
      MapOL.switchOffSiteDraw();
      MapOL.switchOffCutterLineDraw();
      this.siteDrawMode = false;
      this.selectedZone = this.project.zones.length > 0 ? this.project.zones[0] : undefined;
    },
    exitUnregDrawMode() {
      MapOL.switchOffSiteDraw();
      this.unregSiteDrawMode = false;
    },
    onZoneEditComplete(event) {
      let { data, newValue, field } = event;
      if (newValue.trim().length > 0) data[field] = newValue;
      else event.preventDefault();
    },
    onDrag({ transform }) {
      this.$refs.target.style.transform = transform;
    },
    addTask(task) {
      console.log("addTask");
      task.group = task.group.trim();
      if (this.groups.filter((t) => t.name == task.group).length > 0) {
        task.custom_class = this.groups.filter((t) => t.name == task.group)[0].custom_class;
      } else {
        task.custom_class = `custom_class${this.groups.length + 1}`;
        this.groups.push({
          name: task.group,
          custom_class: `custom_class${this.groups.length + 1}`,
        });
      }
      task.id = `${(this.project.tasks.length == 0 ? 0 : Math.max(...this.project.tasks.map((t) => parseInt(t.id)))) + 1}`;
      this.project.tasks.push(task);
      console.log("addTask this.project.tasks", this.project.tasks);
      this.filterTasks(this.selectedZone);
    },
    setTasks(tasks) {
      const updatedProject = { ...this.project, tasks: tasks };
      this.$store.dispatch("setCurrentProject", { project: updatedProject });
      this.filterTasks(this.selectedZone);
    },
    setSelectedZone(zone) {
      this.selectedZone = zone;
    },
    downloadTemplate() {
      var link = document.createElement("a");
      link.target = "_blank";
      if (this.selectedTemplate == "CSV Template") {
        link.href = `/others/CNMP CSV Template.csv`;
      } else {
        link.href = "/template/CNMP Excel Template.xlsm";
      }
      link.click();
      link.remove();
    },
    uploadFile(files) {
      this.file = files[0];
      this.fileName = files[0].name;
    },
    uploadFileSite(files) {
      var theRadius = this.project.bufferRadius;
      let props = this;
      MapOL.siteDrawByGJSON(files[0], theRadius, function (uploadOk, district) {
        if (uploadOk) {
          console.log("uploadOk");
          console.log(uploadOk);
          props.siteDrawMode = true;
          // set 1 initial zone
          props.project.zones = [];
          props.project.zones.push({
            id: 1,
            name: `Zone 1`,
            calculationtype: "A",
            // startDate: '-',
            // endDate: '-'
          });
          props.project.targetDistrict = district;
        }
      });
    },
    uploadFileZone(files) {
      //console.log("enter uploadFileZone")
      var theRadius = this.project.bufferRadius;
      let props = this;
      props.oldZones = [...props.project.zones];
      props.project.zones = [];
      MapOL.zoneDrawByGJSON(files[0], theRadius, function (zoneCount, zoneNameFields, uploadOk, district) {
        if (uploadOk) {
          console.log("zoneCount", zoneCount);
          for (var i = props.project.zones.length; i < zoneCount; i++)
            props.project.zones.push({
              id: i + 1,
              name: `Zone ${i + 1}`,
              calculationtype: "A",
              // startDate: '-',
              // endDate: '-'
            });
          props.importZoneNameFieldOptions = zoneNameFields;
          // console.log("props.project.zones", props.project.zones);
          // console.log("zoneNameFields");
          // console.log(zoneNameFields);
          props.siteDrawMode = true;
          props.project.targetDistrict = district;
        }
      });
    },
    zoneNameFieldChange() {
      console.log("this.importZoneName");
      console.log(this.importZoneName);
      let props = this;
      MapOL.getZoneNameByField(this.importZoneName, function (zoneNames) {
        console.log("zoneNames");
        console.log(zoneNames);
        for (var i = 0; i < props.project.zones.length; i++) {
          let index = props.project.zones.findIndex((z) => z.id === i + 1);
          if (index > -1) {
            props.project.zones[index].name = zoneNames[i];
            let oldZoneId = props.oldZones.filter((z) => z.name == props.project.zones[index].name);
            if (oldZoneId.length > 0) {
              const oldIndex = props.project.zones[index].id;
              let zoneSwitchId = props.project.zones.filter((z) => z.id == oldZoneId[0].id);
              if (zoneSwitchId.length > 0) {
                zoneSwitchId[0].id = oldIndex;
              }
              props.project.zones[index].id = oldZoneId[0].id;
            }
          }
          // props.project.zones[i].name = zoneNames[i];
        }
        console.log("props.project.zones");
        console.log(props.project.zones);
      });
    },
    importActivities() {
      let props = this;
      let group = props.groups.filter((e) => e.name === props.groupName);
      if (group.length == 0) {
        props.groups.push({
          name: props.groupName,
          custom_class: `custom_class${props.groups.length + 1}`,
        });
      }
      group = props.groups[props.groups.length - 1];
      let zone = this.selectedZone.id;
      props.selectedActivities.forEach((ac) => {
        props.project.tasks.push({
          start: DateHelper.getDateString(this.groupDuration[0]),
          end: DateHelper.getDateString(this.groupDuration[1]),
          name: ac,
          id: `${(props.project.tasks.length == 0 ? 0 : Math.max(...props.project.tasks.map((t) => parseInt(t.id)))) + 1}`,
          group: props.groupName,
          custom_class: group.custom_class,
          zone: zone,
          cwModel: "",
          activityModel: "",
          cwOrActivityModel: "",
        });
      });
      props.filterTasks(props.selectedZone);
      props.selectedActivities = [];
      props.showCWAct = false;
    },
    confirmOverwriteProject(event) {
      let props = this;
      if (props.project.tasks.length > 0) {
        this.$confirm.require({
          target: event.currentTarget,
          message: "Do you want to overwrite your previous tasks?",
          icon: "pi pi-info-circle",
          accept: () => {
            let promises = [];
            props.project.tasks.forEach((task) => {
              if (task.id_0) {
                promises.push(
                  this.axios
                    .delete(`${this.apiEndpoint}task?id=${task.id_0}`)
                    .then((response) => { })
                    .catch((error) => {
                      console.log(error);
                    }),
                );
                promises.push(
                  this.axios
                    .delete(`${this.apiEndpoint}projectpme/projectid/${props.project.id}/taskid/${task.id}`)
                    .then((response) => { })
                    .catch((error) => {
                      console.log(error);
                    }),
                );
              }
            });
            Promise.all(promises).then(function () {
              props.project.tasks = [];
              props.importSchedule();
            });
          },
          reject: () => {
            props.importSchedule();
          },
        });
      } else {
        props.importSchedule();
      }
    },
    importSchedule() {
      console.log("import");
      let props = this;
      this.importing = "pi pi-spin pi-spinner";
      if (props.file.type == "text/csv") {
        var reader = new FileReader();
        reader.readAsText(props.file, "UTF-8");
        reader.onload = function () {
          // Remove UTF-8 BOM if present
          let csvText = reader.result;
          if (csvText.charCodeAt(0) === 0xfeff) {
            csvText = csvText.slice(1);
          }
          const csvData = Papa.parse(csvText, {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: false,
          });

          const lines = csvData.data;
          console.log("lines", lines);

          // Get header keys from Papa Parse
          const headers = Object.keys(lines[0] || {});
          let zoneIndex = headers.findIndex((h) => h.toLowerCase().includes("zone"));
          let groupIndex = headers.findIndex((h) => h.toLowerCase().includes("construction") || h.toLowerCase().includes("group"));
          let taskIndex = headers.findIndex((h) => h.toLowerCase().includes("activity") || h.toLowerCase().includes("job"));
          let startIndex = headers.findIndex((h) => h.toLowerCase().includes("start") || h.toLowerCase().includes("from"));
          let endIndex = headers.findIndex((h) => h.toLowerCase().includes("end") || h.toLowerCase().includes("to"));

          // Get actual header names
          let zoneKey = zoneIndex >= 0 ? headers[zoneIndex] : null;
          let groupKey = groupIndex >= 0 ? headers[groupIndex] : null;
          let taskKey = taskIndex >= 0 ? headers[taskIndex] : null;
          let startKey = startIndex >= 0 ? headers[startIndex] : null;
          let endKey = endIndex >= 0 ? headers[endIndex] : null;

          for (var i = 0; i < lines.length; i++) {
            let row = lines[i];
            let newData = Object.values(row);
            if (newData.filter((element) => element).length == 0) continue;
            if (
              isNaN(Date.parse(newData[startIndex])) ||
              Date.parse(newData[startIndex]) < 0 ||
              DateHelper.getDateString(Date.parse(newData[startIndex])) == null
            ) {
              window.alert(`Invalid date format found in your csv: ${row[startKey]}`);
              break;
            }
            if (
              isNaN(Date.parse(newData[endIndex])) ||
              Date.parse(newData[endIndex]) < 0 ||
              DateHelper.getDateString(Date.parse(newData[endIndex])) == null
            ) {
              window.alert(`Invalid date format found in your csv: ${row[endKey]}`);
              break;
            }
            if (Date.parse(newData[startIndex]) > Date.parse(newData[endIndex])) {
              window.alert(`End date is earlier than start date: ${row[startKey]} - ${row[endKey]}`);
              break;
            }
            if (props.groups.filter((e) => e.name === row[groupKey]).length == 0) {
              props.groups.push({
                name: row[groupKey] == "" ? "-" : row[groupKey],
                custom_class: `custom_class${props.groups.length + 1}`,
              });
            }
            let zone = [{ id: "1" }];
            if (zoneKey !== null) {
              zone = props.project.zones.filter((z) => z.name == row[zoneKey].trim());
              if (zone.length == 0) {
                window.alert(`Zone name does not exist in your project: ${row[zoneKey].trim()}`);
                props.filterTasks(props.selectedZone);
                return;
              }
            }
            props.project.tasks.push({
              start: DateHelper.getDateString(Date.parse(row[startKey])),
              end: DateHelper.getDateString(Date.parse(row[endKey])),
              name: row[taskKey].trim(),
              id: `${props.project.tasks.length + 1}`,
              group: row[groupKey].trim() == "" ? "-" : row[groupKey].trim(),
              custom_class: props.groups.filter((e) => e.name === (row[groupKey] == "" ? "-" : row[groupKey]))[0].custom_class,
              zone: zone[0].id,
              cwModel: "",
              activityModel: "",
              cwOrActivityModel: "",
            });
          }
          //props.findSimilarTextWithCWAndActivity();
          props.importing = "";
          props.filterTasks(props.selectedZone);
          document.getElementById("uploadSchedule").value = "";
          props.fileName = "Upload";
          props.file = undefined;
        };
      }
    },
    findSimilarTextWithCWAndActivity() {
      let props = this;
      // try matching the whole text of CW to the data
      props.constructionWorks.forEach((element) => {
        var currentCW = element.name;

        //loop for each data
        props.project.tasks.forEach((el) => {
          if (el.name.toLowerCase().indexOf(currentCW.toLowerCase()) !== -1) {
            el.cwModel = currentCW;
            el.cwOrActivityModel = "Construction Work";
          }
        });
      });

      // try matching the whole text of Activities to the remaining data
      props.activities.forEach((element) => {
        var currentAct = element.name;

        //loop for each data
        props.project.tasks.forEach((el) => {
          if (el.name.toLowerCase().indexOf(currentAct.toLowerCase()) !== -1 && el.cwOrActivityModel === "") {
            el.activityModel = currentAct;
            el.cwOrActivityModel = "Activity";
          }
        });
      });

      //try to match word by word of CW to the remaining data
      props.constructionWorks.forEach((element) => {
        var currentCW = element.name;

        if (currentCW.indexOf(" ") !== -1) {
          var cwWords = currentCW.split(" ");
          cwWords.forEach((word) => {
            //loop for each data
            props.project.tasks.forEach((el) => {
              if (el.name.toLowerCase().indexOf(word.toLowerCase()) !== -1 && el.cwOrActivityModel === "") {
                el.cwModel = currentCW;
                el.cwOrActivityModel = "Construction Work";
              }
            });
          });
        }
      });
    },
    initGroups(projectRef) {
      console.log("initGroups");
      let props = this;
      for (var i = 0; i < projectRef.tasks.length; i++) {
        if (props.groups.filter((e) => e.name === projectRef.tasks[i].group).length == 0) {
          props.groups.push({
            name: projectRef.tasks[i].group,
            custom_class: `custom_class${props.groups.length + 1}`,
          });
        }
        projectRef.tasks[i].custom_class = props.groups.filter((e) => e.name === projectRef.tasks[i].group)[0].custom_class;
      }
      return projectRef;
    },
    initCWActPMEs() {
      let props = this;
      this.axios.get(`${this.apiEndpoint}cwactpme?type=cwact`).then((response) => {
        props.cwActs = response.data;
        let allActs = [...new Set(props.cwActs.map((cw) => cw.activities).flat())];
        props.cwActs.push({ name: "All", activities: allActs });
        props.selectedCw = props.cwActs[0];
        props.groupName = props.selectedCw.name;
        this.axios.get(`${this.apiEndpoint}cwactpme?type=construction`).then((response) => {
          props.constructionWorks = response.data;
          props.constructionWorks.forEach((cw) => {
            cw.equipments.forEach((e) => {
              e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
            });
          });
          props.axios.get(`${this.apiEndpoint}cwactpme?type=activities`).then((response) => {
            props.activities = response.data;
            props.activities.forEach((ac) => {
              ac.equipments.forEach((e) => {
                e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
              });
            });
          });
        });
      });
    },
    getDate(date) {
      return DateHelper.getDate(date);
    },
    updateProjectDate() {
      if (this.project.tasks.length > 0) {
        this.project.commencementDate = DateHelper.getDateString(
          new Date(
            Math.min(
              ...this.project.tasks.map((element) => {
                return DateHelper.getDate(element.start);
              }),
            ),
          ),
        );
        this.project.completionDate = DateHelper.getDateString(
          new Date(
            Math.max(
              ...this.project.tasks.map((element) => {
                return DateHelper.getDate(element.end);
              }),
            ),
          ),
        );
      } else {
        this.project.commencementDate = null;
        this.project.completionDate = null;
      }
    },
    openCWAct() {
      this.showCWAct = true;
    },
    updateEquipmentGroup(task) {
      console.log(task);
      this.project.equipments.filter((e) => e.task == task.id).forEach((e) => (e.group = task.group));
      console.log(this.project.equipments.filter((e) => e.task == task.id));
    },
  },
  beforeMount() {
    this.initCWActPMEs();
    this.initGroups(this.project);
  },
  mounted() {
    this.project.hasNeighbors = this.project.unregisteredNeighbours.length > 0;
    this.activeIndex = this.$route.query.activeIndex ? parseInt(this.$route.query.activeIndex) : 0;
    this.initializeSubmissionPurpose();
  },
};
</script>

<style lang="less">
.menuPanel {
  width: calc(100vw);
  position: fixed;
  left: 0px;
  bottom: 0px;
  background-color: white;
  z-index: 10;
}

.target {
  width: 80vw;
  position: absolute;
  transform: translate(13%, 0%);
}

.minimizeWindow {
  width: 60vw;
  position: absolute;
  transform: translate(30%, 0%);
  bottom: 10px;
  overflow: hidden;
}

.contentPanel {
  width: 100%;
  height: calc(100vh - 228px - 4rem);
  text-align: left;
}

.fieldLabel {
  line-height: 30px;
  text-align: left;
}

.p-card .p-card-footer {
  height: 40px !important;
  padding: 0 !important;
}

.p-card-content {
  padding: 0.75rem 0;
}

.p-scrollpanel-content {
  padding-bottom: 0px !important;
}

.field.grid,
.formgrid.grid {
  margin: 0px;
}

#cwlist>div>ul>li.p-listbox-item {
  padding: 0rem 1rem;
}

#aclist>div>ul>li.p-listbox-item {
  padding: 0rem 1rem;
}
</style>
<style scoped>
.p-card-body {
  padding: 0.75rem;
}

.field>label {
  float: left;
  padding-right: 10px;
}

.verticalBoxContainer {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: 1px solid #ced4da;
  border-radius: 3px;
  padding: 5px;
}
</style>
<style lang="scss" scoped>
::v-deep(.p-scrollpanel) {
  p {
    padding: 0.5rem;
    line-height: 1.5;
    margin: 0;
  }

  &.custombar1 {
    .p-scrollpanel-wrapper {
      border-right: 9px solid var(--surface-ground);
    }

    .p-scrollpanel-bar {
      background-color: var(--primary-color);
      opacity: 1;
      transition: background-color 0.2s;

      &:hover {
        background-color: #00991a;
      }
    }
  }
}
</style>
